<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-align-bottom`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 13.21C14.4584 13.21 14.8301 13.5816 14.8301 14.04C14.8298 14.4982 14.4583 14.8701 14 14.8701H2C1.54189 14.87 1.17015 14.4981 1.16992 14.04C1.16992 13.5817 1.54174 13.2101 2 13.21H14ZM4 4.78809C4.45822 4.78809 4.8298 5.16 4.83008 5.61816V11.3193H3.16992V5.61816C3.1702 5.16011 3.54192 4.78825 4 4.78809ZM8 0.334961C8.45825 0.334961 8.82985 0.706839 8.83008 1.16504V11.3193H7.16992V1.16504C7.17015 0.706941 7.54189 0.335126 8 0.334961ZM12 2.87988C12.4583 2.87988 12.83 3.25166 12.8301 3.70996V11.3193H11.1699V3.70996C11.17 3.25176 11.5418 2.88005 12 2.87988Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAlignBottom',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
